import React, { ReactNode } from 'react';
import { ModalsKeys } from 'global';
import { Close } from '@mui/icons-material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { blueGrey } from '@mui/material/colors';
import { ModalsContainer } from 'components/shared/Modals';
import { drawerWidth } from 'modules/portalNotifications/constants';
import { Drawer, IconButton, Paper, Stack, Typography } from '@mui/material';
import { collapsedSidebarWidth, expandedSidebarWidth } from 'constants/common';
import { BroadcastNotificationCard, ViewBroadcastDialog } from 'modules/broadcasts';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { ApiContainer } from '../../../api';
import { DrawerFallback } from './DrawerFallback';

interface Props {
  isOpen: boolean;
  isDrawerOpen: boolean;
  onClose: VoidFunction;
}

const modals: Partial<Record<ModalsKeys, ReactNode>> = {
  [ModalsKeys.ViewBroadcastDialog]: <ViewBroadcastDialog />,
};

export const PortalNotificationsDrawer = ({ isOpen, isDrawerOpen, onClose }: Props) => {
  const classes = useStyles({ isDrawerOpen });

  return (
    <>
      <Drawer anchor="left" open={isOpen} variant="persistent" transitionDuration={1} className={classes.drawer}>
        <ApiContainer isDrawerOpen={isOpen}>
          {({ broadcasts, isDataLoading }) => (
            <Stack direction="column" gap="1rem">
              <Paper square className={classes.head}>
                <Typography component="span" variant="h6">
                  Notifications
                </Typography>

                <IconButton onClick={onClose}>
                  <Close sx={{ color: 'black' }} />
                </IconButton>
              </Paper>

              <RenderWithFallback isLoading={isDataLoading} fallBack={<DrawerFallback />}>
                <RenderWithCondition
                  condition={!!broadcasts?.length}
                  fallBack={<Typography align="center">No notifications</Typography>}
                >
                  {broadcasts.map(broadcast => (
                    <BroadcastNotificationCard key={broadcast.broadcastId} initialBroadcast={broadcast} />
                  ))}
                </RenderWithCondition>
              </RenderWithFallback>
            </Stack>
          )}
        </ApiContainer>
      </Drawer>

      <ModalsContainer modalsWithKeys={modals} />
    </>
  );
};

const useStyles = makeStyles<Theme, { isDrawerOpen: boolean }>({
  drawer: {
    width: drawerWidth,

    '& .MuiDrawer-paper': {
      padding: '0 8px',
      width: drawerWidth,
      backgroundColor: blueGrey['50'],
      left: ({ isDrawerOpen }) => (isDrawerOpen ? expandedSidebarWidth : collapsedSidebarWidth),
    },
  },
  head: {
    padding: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});
